export default __webpack_public_path__ + "static/media/$500.60040f4e.png";